import { render } from "./process-dialog.vue?vue&type=template&id=48e65c1f"
import script from "./process-dialog.vue?vue&type=script&lang=js"
export * from "./process-dialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__